import React from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

const LoginCard = () => {
  const [language, setLanguage] = React.useState("en");

  return (
    <Box
      sx={{
        minHeight: "75vh",
        bgcolor: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
   
      <Container
        maxWidth="xs"
        sx={{
          bgcolor: "#F7F7F7",
          borderRadius:"30px",
          border: "1px solid rgba(36, 148, 201, 0.2)",
          p: 4,
          boxShadow: 0,
        }}
      >
        {/* Language Selector */}
        
        <Box display="flex" justifyContent="flex-start" mb={2}>
          <FormControl size="small">
            <Select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              sx={{
                borderRadius: "12px",
                // border: "0.2px solid red",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(36, 148, 201, 0.15)", // default black border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(36, 148, 201, 0.15)", // black on hover
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(36, 148, 201, 0.15)", // black on focus
                },
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 300,
                  fontSize: "18px",
                },
              }}
              startAdornment={
                <img
                  src="https://flagcdn.com/us.svg"
                  alt="flag"
                  width={24}
                  height={24}
                  style={{
                    marginRight: 8,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              }
            >
              <MenuItem value="en" sx={{ fontSize: "20px", fontWeight: 300 }}>
                English
              </MenuItem>
              <MenuItem value="ar" sx={{ fontSize: "20px", fontWeight: 300 }}>
                Arabic
              </MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Title */}
        <Typography variant="body4" style={{fontWeight:'500'}} gutterBottom>
          Login
        </Typography>

        {/* Email */}
        <Box mt={2}>
          <Box mb={2}>
            <Typography variant="body1" style={{fontSize:"16px"}} fontWeight={400} mb={0.5} color="rgba(102, 112, 133, 1)">
              Email
            </Typography>
            <TextField
              placeholder="Enter email"
              fullWidth
              margin="none"
              size="small"
                sx={{
                "& input": {
                  fontSize: "18px", // font size for input text
                  color: "#000", // optional: input text color
                  fontWeight:"500",
                },
                "& input::placeholder": {
                  fontSize: "16px", // font size for placeholder text
                  color: "#999", // optional: placeholder color
                  opacity: 1, // ensures placeholder color is fully visible
                },
              }}
            />
          </Box>

          {/* Password Field */}
          <Box mb={1.5}>
            <Typography variant="body1" style={{fontSize:"16px"}} fontWeight={400} mb={0.5} color="rgba(102, 112, 133, 1)">
              Password
            </Typography>
            <TextField
              type="text"
              placeholder="Enter password"
              fullWidth
              margin="none"
              size="small"
              sx={{
                "& input": {
                  fontSize: "18px", // font size for input text
                  color: "#000", // optional: input text color
                  fontWeight:"500",
                },
                "& input::placeholder": {
                  fontSize: "16px", // font size for placeholder text
                  color: "#999", // optional: placeholder color
                  opacity: 1, // ensures placeholder color is fully visible
                },
              }}
            />
          </Box>
        </Box>
        {/* Forget Password */}
        <Box textAlign="left" mt={3}>
          <Typography
            variant="body2"
            color="primary"
            sx={{ cursor: "pointer",color:'rgba(36, 148, 201, 1)',fontWeight:'400' }}
          >
            Forget Password?
          </Typography>
        </Box>

        {/* Create Account Button */}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 3, textTransform: "none", borderRadius: 2,backgroundColor:'rgba(36, 148, 201, 1)' }}
        >
         Login
        </Button>

        {/* Open Account Link */}
        <Box mt={4} textAlign="center">
          <Typography variant="body2" style={{color:'rgba(102, 112, 133, 1)'}} >
            New to BBCorp?{" "}
            <Typography
              component="span"
              variant="body2"
              color="primary"
              sx={{ cursor: "pointer", fontWeight: 500 ,color:'rgba(36, 148, 201, 1)'}}
            >
              Open an account
            </Typography>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default LoginCard;
